import { Body, SmallHeading2 } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const Section = styled.div`
  margin: 24px 0 48px;
`;

const Container = styled.div`
  display: grid;
  gap: 16px;
  margin-top: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.creme};
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  width: 100%;
  height: 100%;

  svg {
    transition: transform 0.3s;
  }

  &:hover {
    svg {
      transform: translateX(10px);
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
  }
`;

const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  height: 100%;
  gap: 32px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  div {
    p {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    display: grid;
    gap: 32px;
    align-items: center;
    grid-template-columns: auto max-content;
  }
`;

const CardDate = styled(Body)`
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
`;

const CardReadMoreWrapper = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: space-between;
`;

const CardReadMore = styled(SmallHeading2)`
  color: ${({ theme }) => theme.colors.textBlack};
  width: max-content;
`;

const S = {
  Section,
  Container,
  Card,
  CardTextWrapper,
  ContentWrapper,
  CardDate,
  CardReadMoreWrapper,
  CardReadMore,
};

export default S;
